export const BREAKPOINT_MOBILE = 600;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_DESKTOP = 1024;
